import styled from 'styled-components';

export const Flex1 = styled.div`
  flex: 1;
  height: 100%;
`;
export const Wrapper = styled(Flex1)``;

export const ClaimMiles = styled(Flex1)``;

export const ClaimMilesContent = styled.div`
  height: 100%;

  @media (max-width: ${({ theme }) => theme.media.lg}) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const Logs = styled.div`
  height: fit-content;
  flex: 1;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    flex-grow: 0;
  }
`;
export const ClaimMilesTitle = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;

export const RowItem = styled.h2`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 100% !important;
    max-width: unset;
    min-width: unset;
    flex: auto;
    margin-bottom: ${({ theme }) => theme.spacing.x3};
    flex-grow: 0;
  }
`;

export const ClaimMilesForm = styled.form`
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-size: contain;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 100%;
    background-image: none !important;
  }
`;
export const ClaimMilesDevider = styled.div`
  display: flex;
  border: 1px solid #d8dbdf;
  position: relative;
  margin: ${({ theme }) => theme.spacing.x12} 0 ${({ theme }) => theme.spacing.x10};
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    margin: ${({ theme }) => `${theme.spacing.x6} 0`};
  }
`;
export const ClaimMilesDeviderSpan = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #d8dbdf;
  background: #fff;
  padding: 0.25em;
`;

export const ClaimMilesBtnWrap = styled.button`
  margin-inline-start: unset !important;
`;
export const ClaimMileFormBox = styled(Flex1)`
  max-width: 314px;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 100%;
    max-width: unset;
  }
`;
export const ClaimMileFormBoxCard = styled(Flex1)``;

export const ClaimHeadTabale = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
  width: 100%;
`;

export const ClaimActionTabale = styled.div`
  width: 20px;
`;
export const ClaimStatusTabale = styled.div`
  width: 100px;
`;

export const Middle = styled.div`
  margin: auto;
  opacity: 1;
`;
